import React from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FeesSection } from './FeesSection';
import { RebatesSection } from './RebatesSection';
import { AftermarketProductsSection } from './AftermarketProductsSection';
import { QuoteArrayFieldsProps } from '../../../types';

type Props = QuoteArrayFieldsProps;

export const QuoteArrayFields = (props: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <FeesSection {...props} />
      <AftermarketProductsSection {...props} />
      <RebatesSection {...props} />
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    gap: '1rem',
    display: 'flex',
    flexDirection: 'column',

    '& .quoteSection': {
      gap: '1rem',
      display: 'flex',
      flexDirection: 'column',

      '& .arrFields': {
        gap: '0.5rem',
        display: 'flex',
        flexDirection: 'column',
      },

      '& .arrField': {
        gap: '0.5rem',
        display: 'grid',
        gridTemplateRows: 'auto 1fr',
      },

      '& .quoteFields': {
        display: 'grid',
        rowGap: '0.5rem',
        columnGap: '1rem',
        gridTemplateColumns: 'repeat(5, 1fr)',
      },
    },
  },
});
